import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import ClientAppDom from 'elements/ClientAppDom'
import ClientNavBar from 'elements/ClientNavBar'
import News from 'components/news'
import { EasinsureClaims } from 'components/easinsure/claims'
import { EasinsureContracts } from 'components/easinsure/contracts'
import Webapps from 'components/webapps'
import ClientProfile from 'elements/ClientProfile'
import { setAppModule, setOpened, fetchClientData, logout } from 'state/actions'
import c from 'state/constants'
import i18n from 'lib/i18n'

const _ = i18n()

@connect(({app, responsive, client}) => ({
	module: app.module,
	isPhone: responsive.isPhone,
	isTablet: responsive.isTablet,
	client,
	opened: app.opened,
	isModifyClient: app.modifyclient === 'true',
}),
	{setAppModule, setOpened, fetchClientData, logout}
)
export default class ClientMain extends Component {
	componentDidMount() {this.props.fetchClientData()}
	// componentDidUpdate() {this.update()}
	// update() {this.props.fetchClientData()}
	render() {
		const {module, client, opened, setAppModule, setOpened, logout, isModifyClient, isPhone, isTablet} = this.props
		const {detail, main, clientDocuments} = client
		const clientName = main.name
		let content
		let noScroll = true
		const onLinkClicked = (item) => {
			if (item.id === 'logout') {
				return logout()
			}
			return setAppModule(c.PROFILE, item.id)
		}
		switch (module) {
			case c.NEWS:
				content = <News/>
				noScroll = false
				break
			case c.CONTRACTS:
				content = (
					<EasinsureContracts
						onLinkClicked={setOpened}
						onBackClicked={setOpened}
					/>)
				break
			case c.CLAIMS:
				content = (
					<EasinsureClaims
						onLinkClicked={setOpened}
						onBackClicked={setOpened}
					/>)
				break
			case c.WEBAPPS:
				content = <Webapps noHeader/>
				break
			case c.PROFILE:
				content = (
					<ClientProfile
						activeId={opened}
						detail={detail}
						isModifyClient={isModifyClient}
						documents={clientDocuments}
						main={main}
						onLinkClicked={onLinkClicked}
						isPhone={isPhone}
						isTablet={isTablet}
					/>)
				break
			default:
				content = _('unknownModule')
		}

		return (
			<ClientAppDom
				noScroll={noScroll}
				content={content}
				navBar={
					<ClientNavBar
                        clientName={clientName}
                        module={module}
                        onLinkClicked={setAppModule}
                        isPhone={isPhone}
						isTablet={isTablet}
					/>
				}
			/>
		)
	}
}
ClientMain.propTypes = {
	setAppModule: PropTypes.func.isRequired,
	setOpened: PropTypes.func.isRequired,
	fetchClientData: PropTypes.func.isRequired,
	logout: PropTypes.func.isRequired,
	module: PropTypes.string,
	isPhone: PropTypes.bool,
	isTablet: PropTypes.bool,
	client: PropTypes.object,
	opened: PropTypes.string,
	isModifyClient: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./components/Easinsure.jsx